import React from 'react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface SimpleEllipsisProps {
  children: React.ReactNode;
  className?: string;
  lines?: number;
  maxLength?: number;
  tooltip?: boolean;
}

export const SimpleEllipsis: React.FC<SimpleEllipsisProps> = ({
  children,
  className,
  lines = 1,
  maxLength = 100,
  tooltip = true
}) => {
  const text = typeof children === 'string' ? children : children?.toString() || '';
  const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  const isTruncated = text.length > maxLength;

  const getClassName = () => {
    switch (lines) {
      case 1:
        return 'truncate';
      case 2:
        return 'line-clamp-2';
      case 3:
        return 'line-clamp-3';
      default:
        return 'truncate';
    }
  };

  const content = (
    <div className={cn(getClassName(), className)}>
      {truncatedText}
    </div>
  );

  // Only show tooltip if text is actually truncated and tooltip is enabled
  if (tooltip && isTruncated) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {content}
          </TooltipTrigger>
          <TooltipContent
            className="max-w-xs"
            side="top"
          >
            <p className="break-words">{text}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
};

export default SimpleEllipsis;